module.exports = __webpack_public_path__ + "static/img/sw.4f28e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/sw.png
// module id = doke
// module chunks = 1